import type { GiftContentType } from '@/api/types/gift';
export { calculateEqualTierProgress } from '@/domain/cart/gift-exposure/progress';

export interface GiftDialogTerms {
  show?: boolean;
  label?: string;
  title?: string;
  content?: string;
  contentType?: GiftContentType;
}

export interface GiftRuleContent {
  title: string;
  content: string;
  contentType: Exclude<GiftContentType, ''>;
}

export interface GiftProgressTierInput {
  id: string | number;
  reached?: boolean;
  current?: boolean;
}

export type GiftProgressTierState = 'upcoming' | 'reached' | 'current';

export function resolveGiftProgressTierStates<T extends GiftProgressTierInput>(tiers: T[]) {
  return tiers.map((tier) => ({
    id: tier.id,
    state: (tier.current
      ? 'current'
      : tier.reached
        ? 'reached'
        : 'upcoming') as GiftProgressTierState,
  }));
}

export function normalizeGiftProgressPercent(value?: number) {
  if (value === undefined || !Number.isFinite(value)) return undefined;

  return Math.min(100, Math.max(0, value));
}

const hasHtmlTags = (content: string) => /<\/?[a-z][\s\S]*>/i.test(content);

export function resolveGiftRuleContent(
  terms: GiftDialogTerms | undefined,
  fallback: GiftRuleContent,
): GiftRuleContent {
  const content = terms?.content || fallback.content;

  return {
    title: terms?.title || '',
    content,
    contentType:
      terms?.contentType === 'html' || hasHtmlTags(content)
        ? 'html'
        : terms?.content
          ? 'text'
          : fallback.contentType,
  };
}
